
import AuthHelper, { HeadersEnum, HeaderValueEnum } from "../heplers/AuthHelper";
import FetcherFactory, { CreateFetchOption } from "./Fetcher";

export class API {

  static BearerKey: string = "token";

  static CODE_OK = 2000;
  static CODE_ERROR = 5000;

  static ROOT_URL = process.env.REACT_APP_ROOT_URL; // "http://localhost:3334";// @@@


  static SHOW_API_LOG?: "" | "DEBUG" | "SIMPLE" = process.env.REACT_APP_SHOW_API_LOG as any; // "":不顯示; "DEBUG":全部顯示; "SIMPLE":簡單顯示;

  /**
   * 指定用 POST 執行; 某些方法有敏感字眼，不想直接顯示在網址上
   * 注意! 應該還是明碼傳輸，只是不會顯示在網址
   * TODO 找安全的方式
   */
  static async Call_POST(endpoint: string, body: any | undefined): Promise<ApiResult> {
    const rslt = API.Call_RESTful("POST", endpoint, undefined, body);
    return rslt;
  }

  /**
  * 指定用 GET 執行; 故意與 RESTful 分開，之後比較好找
  */
  static async Call_GET(endpoint: string, query_params: { [string: string]: string } | undefined): Promise<ApiResult> {
    const rslt = API.Call_RESTful("GET", endpoint, query_params, undefined);
    return rslt;
  }


  /**
   * 
   * 
   * @param {string} method GET/POST/PUT/DELETE/PATCH
   * @param {string} endpoint "http://localhost:3334" + "/dao/emp" 後半段的網址 就是 endpoint 不含 query params string
   * @param query_params 原本 ?id=123&date=2022-11-13 改為 {"id": "123", "date", "2022-11-13"} 物件傳入 key/value 都是 string 格式
   * @param {any} body 就是要 Update/Insert 的物件 (完整 或 部分的物件)
   */
  static async Call_RESTful(method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH",
    endpoint: string, query_params: { [key: string]: string } | undefined = undefined,
    body: any | undefined = undefined): Promise<ApiResult> {

    /*
    * 專門用來簡單 CRUD 物件
    * 如果 Get 有其他查詢物件則使用 query_params = {key:value, key:value...} 格式
    * 注意! 雖然直接放入變數 {A, B, C} 相當於 {"A":A, "B":B, "C":C}，但考慮到混淆，可能不要這麼用比較好??
    */
    try {

      if (API.ROOT_URL == null) {
        throw Error("請設定 process.env.REACT_APP_ROOT_URL !!!");
      }

      if (!(endpoint.indexOf("/") > -1)) {
        endpoint = "/" + endpoint;
      }

      let request_url = `${window.location.protocol}//${API.ROOT_URL}${endpoint}`;

      if (query_params !== undefined) {
        const query_string = API.EncodeQueryData(query_params);
        if (query_string !== "") {
          request_url = `${request_url}?${query_string}`;
        }
      }

      //#region DEBUG
      if (API.SHOW_API_LOG != null) {
        if (API.SHOW_API_LOG === "DEBUG") {
          console.log(`[${method}] url:${request_url}`);
          if (body != undefined) {
            console.log("body:", JSON.stringify(body));
          }
        } else if (API.SHOW_API_LOG === "SIMPLE") {
          console.log(`[${method}] ${endpoint}`);
        }
      }

      //#endregion

      const headers: Record<string, string> = {
        [HeadersEnum.Accept]: HeaderValueEnum.ApplicationJson,
        [HeadersEnum.ContentType]: HeaderValueEnum.ApplicationJson,
      };

      const bearer = AuthHelper.getAuthorizationBearer(this.BearerKey);
      if (bearer) {
        headers[HeadersEnum.Authorization] = bearer;
      }

      const response = await fetch(request_url, {
        headers: headers,
        method,
        body: JSON.stringify(body),
      });

      if (response.ok) {
        const json = await response.json();
        const jwt = AuthHelper.getAuthorizationFromHeader(response.headers);
        if (jwt) {
          AuthHelper.saveJwtToCookie(this.BearerKey, jwt);
        }
        let api_rslt: ApiResult = json;
        return api_rslt;
      } else {
        throw new Error("Response Error: " + response.status + " !!!");
      }

    } catch (error: any) {
      throw error;
    }
  };


  /** 查詢 <key,value> pairs 轉換為網址安全的編碼 */
  static EncodeQueryData(query_params: { [string: string]: string }) {
    const ret = [];
    for (const key in query_params) {
      if (key) {
        ret.push(`${encodeURIComponent(key)}=${encodeURIComponent(query_params[key])}`);
      }
    }
    return ret.join("&");
  }


  // Rex 版本的 Fetch，Body 還沒正確傳過去
  static async Call_RexFetcher(method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH",
    endpoint: string, query_params: { [key: string]: string } | undefined = undefined,
    body: any | undefined = undefined): Promise<ApiResult> {

    if (!(endpoint.indexOf("/") > -1)) {
      endpoint = "/" + endpoint;
    }

    let url = `${API.ROOT_URL}${endpoint}`;

    if (query_params !== undefined) {
      const query_string = API.EncodeQueryData(query_params);
      if (query_string !== "") {
        url = `${url}?${query_string}`;
      }
    }

    console.log("url---------------------", url);
    const option: CreateFetchOption = {
      method: method,
      // params,
      body: body
    };

    console.log("body----------------------", body);


    const factory = new FetcherFactory<ApiResult>(url, option);// DTO 

    let fetcher = factory.create();


    let rslt = await fetcher();

    console.log("rslt-----------------", rslt);

    // let api_rslt = rslt;

    console.log("rslt-----------------", rslt);

    return rslt;

  }

  /**
   * Fetch() 轉 List<Class> --- (不用此方法的話，只有 data 沒有 function，會出現 xxx not a function 例外)
   * return API.ToClassList(SpecialWorkQuestion, api_rslt.data);
   */
  static ToClassList<T>(type: { new(): T; }, data_list: T[]): T[] {
    return data_list.map(x => Object.assign((new type() as any), x));
  }

  /**
  * Fetch() 轉 Class 物件 --- (不用此方法的話，只有 data 沒有 function，會出現 xxx not a function 例外)
  * return API.ToClassObject(SpecialWorkQuestion, api_rslt.data);  
  */
  static ToClassObject<T>(type: { new(): T; }, data: T): (T | null) {

    if (data === null) {
      return null;
    } else if (data === undefined) {
      return null;
    } else {
      return Object.assign((new type() as any), data);
    }
  }

}


/**
 * API Server 相關錯誤  
 * 為 Response 非 OK 的情況  
 * 通常可能是網路問題 或 主機異常   * 
 */
export class ApiError extends Error {


  constructor(response: Response) {
    super(response.status + " " + response.statusText);
    this.name = "ApiError";

  }
}

export type ApiResult = {
  /** 指出這次呼叫 API 是否正確完成 */
  code: number;

  /** 當 is_ok==false 時，描述失敗原因 */
  message: string;

  /** 正確執行時，經常會回傳一個物件，就放在這裡 response.json() */
  data: any;
}


